import React, { useEffect, useRef } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import styles from './filterCarousel.module.scss';

interface CarouselProps {
  cards: JSX.Element[] | undefined;
  isMobile?: boolean;
}

const FilterCarousel: React.FC<CarouselProps> = ({ cards, isMobile }) => {
  const sliderRef = useRef<Slider>(null);

  useEffect(() => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(0); // Reset to the first slide when isMobile changes
    }
  }, [isMobile]);

  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    variableWidth: true,
    arrows: false,
  };

  return (
    <Slider ref={sliderRef} className={`${styles['carousel']}`} {...settings}>
      {cards?.map((card, index) => (
        <div key={index} className={`${styles['carousel-item']} ${index === 0 ? `${styles['ml-0']}` : ''}`}>
          {card}
        </div>
      ))}
    </Slider>
  );
};

export default FilterCarousel;
